import * as z from "zod/v4";
import { disputeReason } from "./dispute-definition";

export const reasonBreakdownSchema = z.object({
  reason: z.enum(disputeReason),
  count: z.coerce.number(),
  totalAmount: z.coerce.number(),
});

export type ReasonBreakdown = z.infer<typeof reasonBreakdownSchema>;

export const dashboardStatsSchema = z.object({
  totalCount: z.coerce.number(),
  needsResponseCount: z.coerce.number(),
  wonCount: z.coerce.number(),
  lostCount: z.coerce.number(),
  evidenceSubmittedCount: z.coerce.number(),
  underReviewCount: z.coerce.number(),
  totalAmount: z.coerce.number(),
  wonAmount: z.coerce.number(),
  finalizedAmount: z.coerce.number(),
  currency: z.string(),
  reasonBreakdown: z.array(reasonBreakdownSchema).nullish(),
});

export type DashboardStats = z.infer<typeof dashboardStatsSchema>;

export const statsPerCurrencySchema = z.object({
  currency: z.string(),
  totalCount: z.coerce.number(),
  needsResponseCount: z.coerce.number(),
  wonCount: z.coerce.number(),
  lostCount: z.coerce.number(),
  evidenceSubmittedCount: z.coerce.number(),
  underReviewCount: z.coerce.number(),
  totalAmount: z.coerce.number(),
  wonAmount: z.coerce.number(),
  finalizedAmount: z.coerce.number(),
});

export interface StatsPerCurrency
  extends z.infer<typeof statsPerCurrencySchema> {}

export const reasonBreakdownByCurrencySchema = z.object({
  reason: reasonBreakdownSchema.shape.reason,
  currency: z.string(),
  count: z.coerce.number(),
  totalAmount: z.coerce.number(),
});

export interface ReasonBreakdownByCurrency
  extends z.infer<typeof reasonBreakdownByCurrencySchema> {}
